function isBlacklisted(cse) {
  const isVangraafPlWithDeId =
    cse.config.merchant.apiId === '3c3cdfd6-ef61-4cea-ad2d-0668309a43b2' &&
    window.location.pathname.indexOf('/pl') === 0

  const isTenantBlacklisted = isVangraafPlWithDeId || cse.config.merchant.isBlacklisted
  if (isTenantBlacklisted === true) {
    console.debug(`8SELECT: 8.SDK is disabled via config`)
  }

  return isTenantBlacklisted
}

export default isBlacklisted
